<div id="etrees-counters-plr-lat">
  <p-tabView *ngIf="authenticationService?.userCurrent?.permissions?.canActivateMqttCounters">

    <p-tabPanel>
      <ng-template pTemplate="header"><b>Live E-Trees Data through MQTT</b> &nbsp;
        <i [ngClass]="{'text-warnig': !authenticationService.userAuthenticated, 'text-danger': awsService.awsConfigDataReceived && !awsService.awsMqttPortsCountersActivationDate, 'text-success': awsService.awsConfigDataReceived && awsService.awsMqttPortsCountersActivationDate}" [title]="awsService.awsMqttPortsCountersActivationDate? 'Activated' : 'Need activation'"
           class="fa fa-circle"
           style="cursor:default">
        </i>&nbsp;
        <i [ngClass]="{'text-warnig': !authenticationService.userAuthenticated, 'text-danger': awsService.awsConfigDataReceived && !awsService.awsMqttEtreesCountersActivationDate, 'text-success': awsService.awsConfigDataReceived && awsService.awsMqttEtreesCountersActivationDate}" [title]="awsService.awsMqttEtreesCountersActivationDate? 'Activated' : 'Need activation'"
           class="fa fa-circle"
           style="cursor:default">
        </i>&nbsp;
        <i [ngClass]="{'text-warnig': !authenticationService.userAuthenticated, 'text-danger': awsService.awsConfigDataReceived && !awsService.awsMqttEtreesPlrLatActivationDate, 'text-success': awsService.awsConfigDataReceived && awsService.awsMqttEtreesPlrLatActivationDate}" [title]="awsService.awsMqttEtreesPlrLatActivationDate? 'Activated' : 'Need activation'"
           class="fa fa-circle"
           style="cursor:default">
        </i>&nbsp;
      </ng-template>
      <p-fieldset [toggleable]="true">
        <ng-template pTemplate="header"> MQTT technical data</ng-template>
        <div>
          <div class="info">
            You can have access to your E-trees live counters every minute also through Amazon MQTT or WSS protocols
            using the IoT Core AWS service: <br>
            <!--            - First/last ports connection data (rx/tx power, interface status, input/output bytes, ...) (those ports can be share among different E-Trees you own), <br>-->
            <!--            - E-Trees specific data (Input packets, Header Compressed Packets, Padding Removal Packets, Size Errored Packets, ...) (those data -->
            <!--            <br>-->
            - First/last ports connection data: endpoint '/crosscos_connections_counters' <br>
            - E-Trees specific data: endpoint '/etrees_in_out_counters' <br>
            - E-Trees PLR/latency data: endpoint '/etrees_plr_lat_values' <br>
            <br>
            See <a href="https://docs.aws.amazon.com/iot/latest/developerguide/iot-connect-devices.html"
                   target="_blank">AWS documentation</a>
            and <a href="https://docs.aws.amazon.com/iot/latest/developerguide/x509-client-certs.html" target="_blank">authentication
            using certificates</a>.<br>
            Access certificates are created and provided at the activation. <br>
            <br>
            A mapping between E-Trees data and MQTT json data is made through 'key' and 'key3', available in the
            'reference data' tab:<br>
            - use 'key' value for access to each connection counters data, <br>
            - use 'key3' value for access to each E-Trees counters data, <br>
            - use etree.id value for access to each PLR/latency data. <br>
            <br>
            For assistance, please contact <a
            href="mailto:support@mckay-brothers.com">support&#64;mckay-brothers.com</a> <br>
          </div>
        </div>
        <div class="certificate-data">
          MQTT: <b>host</b>: {{ awsService.pythonSampleHost }} &nbsp; <b>port</b>: 8883 <br>
          ClientId: {{ awsService.pythonSampleCompanyId }} <br>
          Topic name: iot{{ awsService.pythonSampleCompanyId }}/# &nbsp; (for all data)<br>
          Topic name: iot{{ awsService.pythonSampleCompanyId }}/etrees_plr_lat_values &nbsp; (for connection counters
          data)<br>
          Topic name: iot{{ awsService.pythonSampleCompanyId }}/etrees_in_out_counters &nbsp; (for E-Trees counters
          data)<br>
          Topic name: iot{{ awsService.pythonSampleCompanyId }}/etrees_plr_lat_values &nbsp; (for PLR/latency data)<br>
          <div *ngIf="awsService.awsMqttKeys">
            Download needed files: (click on each one) <br>
            &nbsp; &nbsp;<a (click)="awsService.onClickDownloadRootCat()"><i class="fa fa-file"></i> Root CA</a><br>
            &nbsp; &nbsp;<a (click)="awsService.onClickDownloadCertPem()"><i class="fa fa-file"></i> Certificate Pem</a><br>
            &nbsp; &nbsp;<a (click)="awsService.onClickDownloadPrivateKey()"><i class="fa fa-file"></i> Private Key</a>
          </div>
          <div *ngIf="!awsService.awsMqttKeys">
            Needed files: (available when activated)<br>
            &nbsp; &nbsp;<i class="fa fa-file"></i> Root CA<br>
            &nbsp; &nbsp;<i class="fa fa-file"></i> Certificate Pem<br>
            &nbsp; &nbsp;<i class="fa fa-file"></i> Private Key
          </div>
        </div>
        <br>

        <table *ngIf="isUserConnected && awsService.awsConfigDataReceived"
               class="tablexxx table-striped table-bordered table-sm">
          <tr>
            <th>Ports counters data</th>
            <td>
              <i [ngClass]="{'text-danger': !awsService.awsMqttPortsCountersActivationDate, 'text-success': awsService.awsMqttPortsCountersActivationDate}" class="fa fa-circle"
                 style="cursor:default"></i>
            </td>
            <td class="text-center">
              <span *ngIf="awsService.awsMqttPortsCountersActivationDate === false || awsService.awsMqttPortsCountersActivationDate === null"
                    class="activated-infoxxx">
                <p-button (onClick)="awsService.onClickActivateMqttPub(AwsServiceType.CROSSCOS_CONNECTIONS_COUNTERS)"
                          label="Activate MQTT publishing through AWS"></p-button>
              </span>
              <span *ngIf="awsService.awsMqttPortsCountersActivationDate" class="activated-infoxxx">
                <p-button (onClick)="awsService.onClickDeactivateMqttData(AwsServiceType.CROSSCOS_CONNECTIONS_COUNTERS, 'Crossco Counters')"
                          label="Deactivate MQTT publishing through AWS"></p-button>
              </span>
            </td>
            <td>
              <span *ngIf="awsService.awsMqttPortsCountersActivationDate">
              Activated: {{ awsService.awsMqttPortsCountersActivationDate | date:datetimeFormat }}
                &nbsp;({{ awsService.awsMqttPortsCountersActivationDate | amTimeAgo }})
              </span>
            </td>
          </tr>
          <tr>
            <th>E-Trees counters data</th>
            <td>
              <i [ngClass]="{'text-danger': !awsService.awsMqttEtreesCountersActivationDate, 'text-success': awsService.awsMqttEtreesCountersActivationDate}" class="fa fa-circle"
                 style="cursor:default"></i>
            </td>
            <td class="text-center">
               <span *ngIf="awsService.awsMqttEtreesCountersActivationDate === false || awsService.awsMqttEtreesCountersActivationDate === null"
                     class="activated-infoxxx">
                <p-button (onClick)="awsService.onClickActivateMqttPub(AwsServiceType.ETREES_IN_OUT_COUNTERS)"
                          label="Activate MQTT publishing through AWS"></p-button>
              </span>
              <span *ngIf="awsService.awsMqttEtreesCountersActivationDate" class="activated-infoxxx">
                <p-button (onClick)="awsService.onClickDeactivateMqttData(AwsServiceType.ETREES_IN_OUT_COUNTERS, 'E-Trees Counters')"
                          label="Deactivate MQTT publishing through AWS"></p-button>
              </span>
            </td>
            <td>
              <span *ngIf="awsService.awsMqttEtreesCountersActivationDate">
              Activated: {{ awsService.awsMqttEtreesCountersActivationDate | date:datetimeFormat }}
                &nbsp;({{ awsService.awsMqttEtreesCountersActivationDate | amTimeAgo }})
              </span>
            </td>
          </tr>
          <tr>
            <th>E-Trees PLR/latency data</th>
            <td>
              <i [ngClass]="{'text-danger': !awsService.awsMqttEtreesPlrLatActivationDate, 'text-success': awsService.awsMqttEtreesPlrLatActivationDate}" class="fa fa-circle"
                 style="cursor:default"></i>
            </td>
            <td class="text-center">
                <span *ngIf="awsService.awsMqttEtreesPlrLatActivationDate === false || awsService.awsMqttEtreesPlrLatActivationDate === null"
                      class="activated-infoxxx">
                <p-button (onClick)="awsService.onClickActivateMqttPub(AwsServiceType.ETREES_PLR_LAT_VALUES)"
                          label="Activate MQTT publishing through AWS"></p-button>
              </span>
              <span *ngIf="awsService.awsMqttEtreesPlrLatActivationDate" class="activated-infoxxx">
                <p-button (onClick)="awsService.onClickDeactivateMqttData(AwsServiceType.ETREES_PLR_LAT_VALUES, 'PLR/Latency values')"
                          label="Deactivate MQTT publishing through AWS"></p-button>
              </span>
            </td>
            <td>
              <span *ngIf="awsService.awsMqttEtreesPlrLatActivationDate">
              Activated: {{ awsService.awsMqttEtreesPlrLatActivationDate | date:datetimeFormat }}
                &nbsp;({{ awsService.awsMqttEtreesPlrLatActivationDate | amTimeAgo }})
              </span>
            </td>
          </tr>
        </table>
      </p-fieldset>

      <div *ngIf="isUserConnected">
        <br>
        <p-fieldset [toggleable]="true">
          <ng-template pTemplate="header"> Python Sample Code</ng-template>
          <pre class="code-sample">
import json
import time

from AWSIoTPythonSDK.MQTTLib import AWSIoTMQTTClient, DROP_OLDEST # install AWSIoTPythonSDK with pip

clientId = '{{ awsService.pythonSampleCompanyId }}'
host = '{{ awsService.pythonSampleHost }}'
port = 8883
rootCAPath = 'AWS_KEYS/test/root-CA.crt'
privateKeyPath = 'AWS_KEYS/test/private.pem.key'
certificatePath = 'AWS_KEYS/test/certificate.pem.crt'

myAWSIoTMQTTClient = AWSIoTMQTTClient(clientId)
myAWSIoTMQTTClient.configureEndpoint(host, port)
myAWSIoTMQTTClient.configureCredentials(rootCAPath, privateKeyPath, certificatePath)
myAWSIoTMQTTClient.configureAutoReconnectBackoffTime(1, 32, 20)
myAWSIoTMQTTClient.configureOfflinePublishQueueing(5, DROP_OLDEST)
myAWSIoTMQTTClient.configureDrainingFrequency(2)  # Draining: 2 Hz
myAWSIoTMQTTClient.configureConnectDisconnectTimeout(10)  # 10 sec
myAWSIoTMQTTClient.configureMQTTOperationTimeout(5)  # 5 sec
myAWSIoTMQTTClient.connect()

def custom_callback_test(client, userdata, message):
    print(" ** << Received << a new message: from topic: " + message.topic)
    message_as_string = message.payload.decode()
    message_as_json = json.loads(message_as_string)
    print(message_as_json)
    print("\n")

topic = 'iot{{ awsService.pythonSampleCompanyId }}/#'
#topic = 'iot{{ awsService.pythonSampleCompanyId }}/crosscos_connections_counters'
#topic = 'iot{{ awsService.pythonSampleCompanyId }}/etrees_in_out_counters'
#topic = 'iot{{ awsService.pythonSampleCompanyId }}/etrees_plr_lat_values'
myAWSIoTMQTTClient.subscribe(topic, 1, custom_callback_test)
print('Connected, waiting for data ...')
time.sleep(60 * 10)
print('... end')
        </pre>
          <!--        </div>-->
        </p-fieldset>
      </div>
    </p-tabPanel>


    <p-tabPanel>
      <ng-template pTemplate="header">Reference Data for MQTT</ng-template>
      <div>
        <!--        <p-panel *ngIf="etreesClientData" [toggleable]="true">-->
        <p-fieldset *ngIf="etreesClientData" [toggleable]="true">
          <ng-template pTemplate="header">E-Trees reference data &nbsp;</ng-template>
          <small><a (copied)="onClickCopyEtreeData()" [appCopyClipboard]="etreesClientDataAsString" class="float-rightxxx"
                    role="button">(<i class="fa fa-clipboard"></i> Copy to clipboard)</a></small>
          <pre class="code-sample">{{ etreesClientData|json }}</pre>
        </p-fieldset>
        <br>
      </div>
    </p-tabPanel>


    <p-tabPanel>
      <ng-template pTemplate="header">Ports Counters Data</ng-template>
      <div>
        <p-fieldset *ngIf="etreesClientData" [toggleable]="true">
          <ng-template pTemplate="header">
            Fields description
          </ng-template>
          <!--          <b>- Key:</b> Key of the connection point: hash(crossco name + strand/wave). <br>-->
          <b>- Key:</b> Key of the connection point, defined in the 'reference data'<br>

          <b>&nbsp; - rx_b:</b> Input bytes <br>
          <b>&nbsp; - rx_p:</b> Input packets <br>
          <b>&nbsp; - rx_e_p:</b> Input packets error <br>
          <b>&nbsp; - rx_hc_p:</b> Header Compressed Packets <br>
          <b>&nbsp; - rx_pr_p:</b> Padding Removal Packets <br>
          <b>&nbsp; - rx_ms_e_p:</b> Size Errored Packets <br>
          <b>&nbsp; - rx_pr_e_p:</b> Padding Removal Errored Packets <br>
          <b>&nbsp; - rx_bo_e_p:</b> Buffer Overflow Packets <br>
          <!--          <b>&nbsp; - xxxx:</b>  <br>-->
          <!--          <b>&nbsp; - xxxx:</b>  <br>-->
          <!--          <b>&nbsp; - xxxx:</b>  <br>-->
          <!--          <b>&nbsp; - xxxx:</b>  <br>-->
          <!--          <b>&nbsp; - xxxx:</b>  <br>-->
          <!--          <b>&nbsp; - xxxx:</b>  <br>-->
          <!--          <b>&nbsp; - xxxx:</b>  <br>-->
          <!--          <b>&nbsp; - xxxx:</b>  <br>-->
          <!--          <b>&nbsp; - xxxx:</b>  <br>-->
          <b>&nbsp; - t:</b> Date/time of the measure of data <br>
          <br>
          Note that some fields counters are not available for all E-Trees endpoints<br>
        </p-fieldset>
        <br>
<!--        <p-fieldset *ngIf="!awsService.crosscosData.lastLoadedData" [toggleable]="true">-->
<!--          <ng-template pTemplate="header"> Ports counters raw data sample</ng-template>-->
<!--          <pre class="code-sample">{{ sampleDataPortsCounters|json }}</pre>-->
<!--        </p-fieldset>-->
<!--        <p-fieldset *ngIf="awsService.crosscosData.lastLoadedData" [toggleable]="true">-->
<!--          <ng-template pTemplate="header"> Last ports counters raw data</ng-template>-->
<!--          <pre class="code-sample">{{ awsService.crosscosData.lastLoadedData|json }}</pre>-->
<!--        </p-fieldset>-->
      </div>
    </p-tabPanel>


    <p-tabPanel>
      <ng-template pTemplate="header">E-Trees counters data</ng-template>
      <div>
        <p-fieldset *ngIf="etreesClientData" [toggleable]="true">
          <ng-template pTemplate="header">
            Fields description
          </ng-template>
          <!--        <p-panel header="> Fields description" [toggleable]="true">-->
          <!--          <b>- Key:</b> Key3 of the connection point: hash(etreeId + IN/OUT + crossco name + strand/wave + vlan + hk). <br>-->
          <b>- Key:</b> Key3 of the connection point, defined in the 'reference data' <br>
          <b>&nbsp; - rx_b / tx_b:</b> Reception/transmission bytes (Reception is in most case the data Clients send
          into the Mckay network; transmission is data going out; in some rare cases this can
          be inverted)<br>
          <b>&nbsp; - rx_p / tx_p:</b> Reception/transmission packets <br>
          <b>&nbsp; - rx_e_p:</b> Reception error packets <br>
          <b>&nbsp; - sp:</b> Speed of the port <br>
          <b>&nbsp; - rx_fcs_e_p:</b> Bad FCS Packets <br>
          <b>&nbsp; - rx_drop_p:</b> Dropped Packets <br>
          <b>&nbsp; - rx_mac_e_p:</b> Incorrect MAC Packets <br>
          <b>&nbsp; - rx_rec_p:</b> Input Recovered Packets <br>
          <b>&nbsp; - i_st:</b> Interface Status <br>
          <b>&nbsp; - t:</b> Date/time of the measure of data <br>
          <br>
          <b>&nbsp; - rx_pow / tx_pow:</b> Power of the signal at the reception/transmission port<br>
          <b>&nbsp; - sfp_t:</b> If present, specific date/time of the rx/tx power <br>
          <br>
          Note that some fields counters are not available for all connection points<br>
        </p-fieldset>
        <br>
<!--        <p-fieldset *ngIf="!awsService.etreesData.lastLoadedData" [toggleable]="true">-->
<!--          <ng-template pTemplate="header"> E-Trees counters raw data sample</ng-template>-->
<!--          <pre class="code-sample">{{ sampleDataEtreesCounters|json }}</pre>-->
<!--        </p-fieldset>-->
<!--        <p-fieldset *ngIf="awsService.etreesData.lastLoadedData" [toggleable]="true">-->
<!--          <ng-template pTemplate="header"> Last E-Trees counters raw data</ng-template>-->
<!--          <pre class="code-sample">{{ awsService.etreesData.lastLoadedData|json }}</pre>-->
<!--        </p-fieldset>-->
      </div>
    </p-tabPanel>

    <p-tabPanel>
      <ng-template pTemplate="header">PLR/Latency Data</ng-template>
      <div>
        <p-fieldset [toggleable]="true">
          <ng-template pTemplate="header">
            Fields description
          </ng-template>
          <!--        <p-panel header="> Fields description" [toggleable]="true">-->
          <b>- Key: the E-Tree id</b> <br>
          <b>&nbsp; - Key:</b> Key2 of the connection point, defined in the 'reference data' <br>
          <b>&nbsp; &nbsp; - plr:</b> The value of PLR in % for this PoP (0 to 100).<br>
          <b>&nbsp; &nbsp; - lat:</b> The value of Latency in ns for this PoP<br>
          <b>&nbsp; &nbsp; - time:</b> The unix time (rounded second) when measure was done/<br>
          <br>
        </p-fieldset>
        <br>
        <!--        <p-panel header="> Raw data sample" *ngIf="!lastRawData" [toggleable]="true">-->
<!--        <p-fieldset *ngIf="!awsService.plrLatData.lastLoadedData" [toggleable]="true">-->
<!--          <ng-template pTemplate="header"> PLR/Latency raw data sample</ng-template>-->
<!--          <pre class="code-sample">{{ sampleDataEtreesPlrLat|json }}</pre>-->
<!--        </p-fieldset>-->
        <!--        <p-panel header="> Last raw data" *ngIf="lastRawData" [toggleable]="true">-->
<!--        <p-fieldset *ngIf="awsService.plrLatData.lastLoadedData" [toggleable]="true">-->
<!--          <ng-template pTemplate="header"> Last PLR/Latency raw data</ng-template>-->
<!--&lt;!&ndash;          <pre class="code-sample">{{ awsService.plrLatData.lastLoadedData|json }}</pre>&ndash;&gt;-->
<!--        </p-fieldset>-->
      </div>
    </p-tabPanel>
  </p-tabView>
  <br><br>

</div>
